module.exports = __webpack_public_path__ + "img/arrowdownswap.05e598ab.svg";